import { FormSubmission } from '../types';
import styles from '../form-submissions.module.css';
import { Sparkles, CheckCircle, XCircle, HelpCircle } from 'lucide-react';

interface AISummarySectionProps {
  submission: FormSubmission;
}

export function AISummarySection({ submission }: AISummarySectionProps) {
  const { qualification, aiSummary } = submission;

  const getQualificationConfig = (qual: FormSubmission['qualification']) => {
    switch (qual) {
      case 'yes':
        return {
          icon: CheckCircle,
          label: 'Qualifies',
          className: styles.qualificationYes,
        };
      case 'no':
        return {
          icon: XCircle,
          label: 'Does Not Qualify',
          className: styles.qualificationNo,
        };
      case 'maybe':
        return {
          icon: HelpCircle,
          label: 'Needs Review',
          className: styles.qualificationMaybe,
        };
    }
  };

  const config = getQualificationConfig(qualification);
  const QualIcon = config.icon;

  return (
    <div className={styles.aiSummarySection}>
      <div className={styles.aiSummaryHeader}>
        <div className={styles.aiSummaryTitle}>
          <Sparkles size={18} className={styles.textOrange} />
          <span>AI Summary</span>
        </div>
        <div className={`${styles.qualificationBadge} ${config.className}`}>
          <QualIcon size={14} />
          {config.label}
        </div>
      </div>
      <p className={styles.aiSummaryText}>{aiSummary}</p>
    </div>
  );
}
